import React from 'react'

const ActiveIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_92_1987)">
      <path
        d="M0 10C0 4.4775 4.4775 0 10 0C15.5225 0 20 4.4775 20 10C20 15.5225 15.5225 20 10 20C4.48 19.9933 0.00666667 15.52 0 10.0008V10ZM2 10C2 14.4183 5.58167 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58167 14.4183 2 10 2C5.58417 2.005 2.005 5.58417 2 9.99917V10ZM5.33333 10C5.33333 8.76232 5.825 7.57534 6.70017 6.70017C7.57534 5.825 8.76232 5.33333 10 5.33333C11.2377 5.33333 12.4247 5.825 13.2998 6.70017C14.175 7.57534 14.6667 8.76232 14.6667 10C14.6667 11.2377 14.175 12.4247 13.2998 13.2998C12.4247 14.175 11.2377 14.6667 10 14.6667C8.76232 14.6667 7.57534 14.175 6.70017 13.2998C5.825 12.4247 5.33333 11.2377 5.33333 10Z"
        fill="#26BC26"
      />
    </g>
    <defs>
      <clipPath id="clip0_92_1987">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default ActiveIcon
